export default __webpack_public_path__ + "static/image047-96cb1be67bb5f728827b44a9492c64c1.gif";